import { LocationsModel } from '../models/locations.model';
import RequestCreator from './helpers/requestCreator';

class Location extends RequestCreator<LocationsModel> {}

const api = new Location('/locations');
export default api;
